// extracted by mini-css-extract-plugin
module.exports = {"root":"iKStNr","value":"YGiF96"};